const ctrls = {};

function parseDom (dom) {
    const pageElements = dom.querySelectorAll('[data-controller]');

    if (pageElements.length) {
        Array.prototype.forEach.call(pageElements, (singleElement) => {
            const attr = singleElement.getAttribute('data-controller');

            if (!attr) {
                return false;
            }

            if (ctrls.hasOwnProperty(attr)) {
                if(!ctrls[attr])
                    return false;

                const instance = ctrls[attr](singleElement);
                if (instance && 'init' in instance) {
                    instance.init();
                }
            }
        });
    }
}

function addController (name, constructor) {
    if (!ctrls.hasOwnProperty(name)) {
        ctrls[name] = constructor;
    }
}

function removeController (name) {
    if (!ctrls.hasOwnProperty(name)) {
        delete ctrls[name];
    }
}

export default {
    add: addController,
    remove: removeController,
    parse: parseDom
};

document.addEventListener('DOMContentLoaded', (e) => {
    parseDom(e.target);
});

document.addEventListener('newDom', (e) => {
    parseDom(e.target);
});
